if (!customElements.get('language-switcher')) {

  class LanguageSwitcher extends HTMLElement {
    constructor() {
      super();
      
      this.select = this.querySelector('select');

      this.select.addEventListener('change', e => {
        const url = this.select.querySelector(`[value="${e.target.value}"]`).getAttribute('data-url');
        window.location.href = url;
      });

    }

  }

  customElements.define('language-switcher', LanguageSwitcher);
    
}
